import React, {  useState } from 'react'
import { Button, Modal, InputGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { passwordRegex } from '../../../utils/constants';
import { setShowFirstResetPasswordResetModal } from '../../../slice/showModalSlice';
import { toast } from 'react-toastify';
import { loadingWrapper } from '../../../utils/loadingWrapper';
import CustomPopover from '../../custom-popover/CustomPopover';
import { setItoken } from '../../../slice/userSlice';
import useLogin from '../../../hooks/useLogin';

const FirstResetPassword = () => {
    const dispatch = useDispatch();
    const show = useSelector((state)=>state.showModal.showFirstResetPasswordModal);
    const {firstResetPassword,resetLoading} = useLogin();

    const [passwordData,setPasswordData] = useState({
        newPassword:"",
        confirmPassword:""
    })

    const [obscurePasswordData, setObscurePasswordData] = useState({
        newPassword: true,
        confirmPassword: true,
    })

    const inputHandler = (e) =>{
        const {name,value} = e.target

        setPasswordData((prevState)=>{return{...prevState,[name]:value}})
    }

    const showPasswordHandler = (name) =>{
        setObscurePasswordData((prevState)=>{return{...prevState,[name]:!obscurePasswordData[name]}})
    }
    
    const closeChangePassword = () =>{
        dispatch(setShowFirstResetPasswordResetModal());
        dispatch(setItoken(null));
        setObscurePasswordData({
            newPassword: true,
            confirmPassword: true,
        });
    }

    const checkPasswordData = () => {
        return !(passwordRegex.test(passwordData.newPassword)
            && passwordRegex.test(passwordData.confirmPassword)
            && passwordData.newPassword === passwordData.confirmPassword
        );
    }

    const sendChangePassword = () => {
        let obj = {
            password:passwordData.newPassword
        };

        firstResetPassword(
            obj,
            ()=>{
                toast.success("Password Cambiata, effettua il login con la nuova password");
                closeChangePassword();
            },
            ()=>{toast.error("Errore cambio password")},
        )
    }




    return (
        <Modal show={show} size="md" onHide={resetLoading ? null : closeChangePassword}>
            <Modal.Header closeButton>
            <Modal.Title className="d-flex justify-content-center w-100">
                <p className="m-0">Cambia Password</p>
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className='d-flex flex-column gap-2'>
                <fieldset className='detail-fieldset flex-column gap-1'>
                <legend className='detail-legend d-flex gap-2 align-items-center'>Password <CustomPopover autoClose={5000} title={"Info Password"} body={<p>la password deve contenere almeno 8 caratteri tra cui uno maiuscolo, uno minuscolo, un numero e un simbolo</p>}/></legend>
                    <p className="text-danger m-0">Hai 5 minuti per effettuare il cambio prima che la sessione scada. Trascorso tale periodo, sarà necessario inoltrare una nuova richiesta.</p>
                    <div className='d-flex flex-column gap-1'>
                        <div className='minW150'>Nuova Password</div>
                        <InputGroup className='inputGroup-focus'>
                            <input className='form-control' type={obscurePasswordData.newPassword ? 'password' : 'text'} name='newPassword' onChange={inputHandler} />
                            <Button
                                onClick={() => showPasswordHandler("newPassword")}>
                                {!obscurePasswordData.newPassword ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-eye-slash-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                                        <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                                    </svg>
                                    ) : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-eye-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                                    </svg>
                                )}
                            </Button>
                        </InputGroup>
                    </div>
                    <div className='d-flex flex-column gap-1'>
                        <div className='minW150'>Conferma Password</div>
                        <InputGroup className='inputGroup-focus'>
                            <input className='form-control' type={obscurePasswordData.confirmPassword ? 'password' : 'text'} name='confirmPassword' onChange={inputHandler} />
                            <Button
                                onClick={() => showPasswordHandler("confirmPassword")}>
                                {!obscurePasswordData.confirmPassword ? (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-eye-slash-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z" />
                                        <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z" />
                                    </svg>
                                    ) : (
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        class="bi bi-eye-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
                                    </svg>
                                )}
                            </Button>
                        </InputGroup>
                    </div>
                </fieldset>
            </div>
            </Modal.Body>
            <Modal.Footer>
            <div className='w-100 d-flex justify-content-center'>
                <Button 
                variant="warning"
                className="btn-green"
                  disabled={checkPasswordData() || resetLoading} onClick={()=>sendChangePassword()}>
                    {loadingWrapper(resetLoading,<>Cambia Password</>)}
                </Button>
            </div>
            <div className='d-flex flex-column justify-content-center w-100'>
                {passwordData.newPassword !== "" && passwordData.confirmPassword !== "" && passwordData.newPassword !== passwordData.confirmPassword && <p className='text-danger m-0'>Le password non corrispondono</p>}
            </div>
            </Modal.Footer>
        </Modal>
    )
}

export default FirstResetPassword